<template>
  <!-- 客服热线/在线客服 浮窗（组件） -->
  <!-- <div class="server-float-box"  @click="onClickOnline()"></div> -->
  <div class="server-container" @click="onClickOnline()">
    <div class="server-box">
      <img class="server-avatar"
        src="https://ump.ems.com.cn/newmail-resources/images/special/avatar-customer-service@3x.png">
      <span class="title">{{ serverTitle }}</span>
      <span class="text">{{ serverText }}</span>
      <i class="iconfont icon-arrow-right" />
    </div>
  </div>
</template>

<script>
import urlConfig from '@/plugin/urlConfig'
import { getUserInfo } from '@/api/index'
import { deAesEcb } from '@/plugin/decode/index'
import store from '@/store'
import { mapState } from 'vuex'
import { checkAppUA } from '@/plugin/channel/setUserChannel'

export default {
  components: {},
  props: {
    serverTitle: {
      type: String,
      default: '咨询在线客服'
    },
    serverText: {
      type: String,
      default: '全国统一客服热线：11183'
    },
    frontVueChannel: {
      type: Number, // 1微信公众号h5  2微信小程序h5  3支付宝公众号h5 4支付宝小程序h5
      default: 0
    }
  },
  data () {
    return {

    }
  },
  filters: {},
  watch: {},
  computed: {
    ...mapState('user', ['isLogin'])
  },
  methods: {
    // 查询用户登录状态
    async searchUserInfo () {
      const info = await getUserInfo()
      if (info && Object.keys(info).length > 0) {
        const { isLogin = 0, openId = '', phone = '', phoneNum = '', userId = '', userName = '' } = info
        let obj = {
          userId,
          userName,
          userPhone: deAesEcb(phone),
          aesEcbPhone: phone,
          enCodePhone: phoneNum, // 加密的手机号,给在线客服带参用的
          isLogin,
          openId
        }
        store.dispatch('user/setUserInfo', obj)
        return obj
      } else {
        return {}
      }
    },

    // 前往在线客服
    async onClickOnline () {
      await this.searchUserInfo()
      const isWXMini = checkAppUA('wxMiniprogram')
      const isAliMini = checkAppUA('aliMiniprogram')
      console.log('isLogin:', this.isLogin, 'isWXMini:', isWXMini, 'isAliMini:', isAliMini)
      // 支付宝小程序和微信小程序渠道需判断当前用户的登录状态
      if (+this.isLogin === 0 && (isWXMini || isAliMini)) {
        // 未登录，需跳转到登录授权页
        if (isWXMini) {
          wx.miniProgram.navigateTo({ url: `/packageA/pages/wxLogin/wxLogin?link=111` })
          return
        }
        if (isAliMini) {
          // eslint-disable-next-line no-undef
          my.redirectTo({ url: `/pages/payLogin/payLogin?pageFlag=101&type=3&goRealName=true` })
        }
      } else {
        const url = urlConfig('onlineServer')
        window.location.href = url
      }
    }

  } /* methods末 */
}
</script>

<style lang="scss" scoped>
$server-bottom: 127px;

.server-float-box {
  width: torem(367px);
  height: torem(61px);
  flex-shrink: 0; // 不被挤压
  margin-bottom: torem(7px);
  // background: url('~@/assets/images/bg-server.png') no-repeat;
  background-size: 100%;
}

$avatarSize: torem(46px); // 客服头像大小

.server-container {
  width: 100%;
  flex-shrink: 0;
  margin-top: torem(20px);

  .server-box {
    position: relative;
    display: flex;
    height: torem(40px);
    align-items: center;
    padding: 0 torem(10px) 0;
    background: #fff4e5;
    border-radius: torem(20px);
    box-shadow: 0 torem(4px) torem(10px) 0 rgba(39, 67, 111, 0.01);

    .title {
      margin-left: $avatarSize;
      color: #333;
      font-size: torem(14px);
      font-weight: 600;
      line-height: torem(20px);
    }

    .text {
      flex: 1;
      padding-top: torem(2px);
      margin-left: torem(10px);
      color: #666;
      font-size: torem(12px);
      line-height: torem(18px);
    }
  }

  .server-avatar {
    position: absolute;
    bottom: 0;
    left: torem(10px);
    width: $avatarSize;
    height: $avatarSize;
  }

  .icon-arrow-right {
    color: #999;
    font-size: torem(20px);
  }
}
</style>
